import axios from 'axios';

async function loginApiKeyCard(baseUrl: string): Promise<string> {
  console.log('process.env.X_API_KEY', process.env.REACT_APP_X_API_KEY);
  const { data } = await axios.post<string>(
    '/login/apikey',
    {},
    {
      baseURL: baseUrl,
      headers: {
        'X-Api-Key': process.env.REACT_APP_X_API_KEY!,
      },
    },
  );
  return data;
}

let tokenCache: string | null = null;
let isFetchingToken = false;

export async function getValidToken(baseUrl: string): Promise<string> {
  if (tokenCache) {
    return tokenCache;
  }

  if (isFetchingToken) {
    await new Promise((res) => {
      const interval = setInterval(() => {
        if (!isFetchingToken) {
          clearInterval(interval);
          res(undefined);
        }
      }, 100);
    });
    return tokenCache!;
  }

  isFetchingToken = true;
  try {
    tokenCache = await loginApiKeyCard(baseUrl);
    return tokenCache;
  } finally {
    isFetchingToken = false;
  }
}

export function clearToken() {
  tokenCache = null;
}
